import { render, staticRenderFns } from "./InstrucoesOperadora.vue?vue&type=template&id=737803d4&"
import script from "./InstrucoesOperadora.vue?vue&type=script&lang=js&"
export * from "./InstrucoesOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports